import authService from './authService';
import { ProductType, ProductOrigin } from '../types/productClassification';
import { ApiResponse } from '../types/common';

/**
 * Serviço para buscar classificações fiscais de produto (Tipo e Origem).
 * Esses dados são listas de referência (lookup) usadas no cadastro de produtos.
 */
class ProductClassificationService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /**
   * Lista todos os tipos de produto
   * GET /api/product-types
   */
  async getProductTypes(): Promise<ProductType[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/product-types');

    if (!response.ok) {
      throw new Error('Falha ao buscar tipos de produto');
    }

    const data: ApiResponse<ProductType[]> = await response.json();
    return data.data!;
  }

  /**
   * Lista todas as origens de produto
   * GET /api/product-origins
   */
  async getProductOrigins(): Promise<ProductOrigin[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/product-origins');

    if (!response.ok) {
      throw new Error('Falha ao buscar origens de produto');
    }

    const data: ApiResponse<ProductOrigin[]> = await response.json();
    return data.data!;
  }
}

export const productClassificationService = new ProductClassificationService();
export default productClassificationService;
